
import Vue from 'vue'
import webfontloader from 'webfontloader'
import { concat } from 'lodash'
import { Scene } from '@/types/scenes'
import { KeyDict } from '@/types'

export default Vue.extend({
  name: 'FontManager',
  props: {
    scenes: {
      type: Object as () => KeyDict<Scene>
    }
  },
  data: () => ({
    loadedFonts: [] as string[]
  }),
  watch: {
    scenes: {
      handler () {
        this.findFontsToLoad()
      },
      deep: true
    }
  },
  mounted () {
    this.findFontsToLoad()
  },
  methods: {
    findFontsToLoad (): void {
      for (const key in this.scenes) {
        const scene = this.scenes[key]
        // castercss chatcss instagramcss tweetcss
        if (scene.scene_layout !== undefined) {
          this.extractFontsFromSceneLayout(scene)
        }
      }
    },
    extractFontsFromSceneLayout (scene: Scene): void {
      // castercss chatcss instagramcss tweetcss
      const layout = scene.scene_layout
      let fonts: string[] = []
      if (layout.castercss && layout.castercss.fontFamily !== undefined) {
        fonts.push(layout.castercss.fontFamily)
      }
      if (layout.chatcss && layout.chatcss.general !== undefined) {
        fonts.push(layout.chatcss.general.font)
      }
      if (layout.instagramcss && layout.instagramcss.text !== undefined && layout.instagramcss.text.font !== undefined) {
        fonts.push(layout.instagramcss.text.font)
      }
      if (layout.tweetcss) {
        layout.tweetcss.handle !== undefined && layout.tweetcss.handle.font !== undefined && fonts.push(layout.tweetcss.handle.font)
        layout.tweetcss.question !== undefined && layout.tweetcss.question.font !== undefined && fonts.push(layout.tweetcss.question.font)
        layout.tweetcss.tweet !== undefined && layout.tweetcss.tweet.font !== undefined && fonts.push(layout.tweetcss.tweet.font)
        layout.tweetcss.username !== undefined && layout.tweetcss.username.font !== undefined && fonts.push(layout.tweetcss.username.font)
      }
      fonts = this.removeDuplicates(fonts)
      fonts = fonts.filter(font => !this.loadedFonts.includes(font) && font !== '')
      if (fonts.length > 0) {
        this.loadFonts(fonts)
      }
    },
    removeDuplicates (array) {
      return array.filter((a, b) => array.indexOf(a) === b)
    },
    loadFonts (fonts: string[]) {
      // console.log('loadFonts', fonts)
      this.loadedFonts = concat(this.loadedFonts, fonts)
      webfontloader.load({
        google: {
          families: fonts
        }
    })
    }
  },
  render (h) {
    return h()
  }
})

